module.exports = [[{"name":"Christian Röpke","title":"Technischer Direktor & Geschäftsführer","image":"/imgs/team/christianroepke.png"},{"name":"Christian Bergmann","title":"Politischer Direktor & Geschäftsführer","image":"/imgs/team/christianbergmann.png"}],[{"name":"Fabian Ludwig","title":"Branding + UX-Designer","image":"/imgs/team/fabianludwig.png"},{"name":"Manuela Stieger","title":"UX + Senior Frontend Entwicklerin","image":"/imgs/team/manuelastieger.png"},{"name":"Corinna von den Driesch","title":"Senior Backend Entwicklerin","image":"/imgs/team/corinnavondendriesch.png"}]]


//////////////////
// WEBPACK FOOTER
// ./src/data/team.json
// module id = 148
// module chunks = 0